<template>
  <div class="about-main">
    <div class="about-ab bgA06"
         :style="{minHeight: clientHeight + 'px'}">
      <div class="page-title">
        <h2>What dose
          <span>WEIMAJIE</span> do？</h2>
        <h3>威马捷服务</h3>
        <div class="page-scroll">
          <img :src="scroll"
               alt="">
        </div>
      </div>
    </div>
    <div class="about-ab bgA07"
         :style="{minHeight: clientHeight + 'px'}">
      <div class="page-content">
        <h2 class="content-title01">Assistance</h2>
        <h3 class="content-subtitle">紧急医疗援助服务内容</h3>
        <Carousel style="width: 840px;margin: 0 auto"
                  v-model="carouselIndex"
                  :autoplay="carouselSetting.autoplay"
                  :autoplay-speed="carouselSetting.autoplaySpeed"
                  :dots="carouselSetting.dots"
                  :radius-dot="carouselSetting.radiusDot"
                  :trigger="carouselSetting.trigger"
                  :arrow="carouselSetting.arrow">
          <CarouselItem>
            <div class="service-flex">
              <div class="service-about">
                <span class="service-icon service01"></span>
                <div class="service-content">
                  <h5>24H×365天多语言对应呼叫中心</h5>
                  <p>24H×365天 中・日・英・韩救援呼叫中心。<br/>10年以上医疗援助经验的客服人员。</p>
                </div>
              </div>
              <div class="service-about">
                <span class="service-icon service02"></span>
                <div class="service-content">
                  <h5>第二诊疗意见</h5>
                  <p>根据客户需求可由顾问医生根据海外治疗情况<br/>提供建议。</p>
                </div>
              </div>
              <div class="service-about">
                <span class="service-icon service03"></span>
                <div class="service-content">
                  <h5>安排就医</h5>
                  <p>根据客户需求安排最合适的医疗机构就医。</p>
                </div>
              </div>
              <div class="service-about">
                <span class="service-icon service04"></span>
                <div class="service-content">
                  <h5>医疗转运及安排回国就医</h5>
                  <p>协助客户联系回国就医医院，安排回国转运，<br/> 提供病床到病床的一站式医疗转运服务。
                  </p>
                </div>
              </div>
              <div class="service-about">
                <span class="service-icon service05"></span>
                <div class="service-content">
                  <h5>医疗费的挂账及代垫支付</h5>
                  <p>在为医疗费挂账的同时进行减额申请并代垫支付。<br/> 根据客户需要提供最少个人负担的保险使用建议。
                  </p>
                </div>
              </div>
              <div class="service-about">
                <span class="service-icon service06"></span>
                <div class="service-content">
                  <h5>遗体处理及送返</h5>
                  <p>协助客户办理当地遗体处理手续并安排遗体送返。</p>
                </div>
              </div>
              <div class="service-about">
                <span class="service-icon service07"></span>
                <div class="service-content">
                  <h5>电话翻译服务</h5>
                  <p>利用三方通话，由客服人员提供电话医疗翻译。</p>
                </div>
              </div>
              <div class="service-about">
                <span class="service-icon service08"></span>
                <div class="service-content">
                  <h5>医疗费减额手续代理</h5>
                  <p>在国内外就医发生昂贵治疗费时的减额交涉代理。 </p>
                </div>
              </div>
              <div class="service-about">
                <span class="service-icon service09"></span>
                <div class="service-content">
                  <h5>安排就医・协助就诊・医疗管理</h5>
                  <p>客服人员全程为您护航，在就诊过程中有任何<br/>不安，可随时致电呼叫中心。
                  </p>
                </div>
              </div>
              <div class="service-about">
                <span class="service-icon service10"></span>
                <div class="service-content">
                  <h5>非医疗救援</h5>
                  <p>行李破损，飞机延误等事故的报案咨询。</p>
                </div>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="page-inbound"
                 style="height: 625px;padding: 20px;">
              <p> B某在境外出差时因半夜突发性的后背疼痛和左下肢麻痹联系威马捷。</p>
              <p>救援客服中心接到患者报案，紧急安排患者急诊就医，并安排垫付治疗费用。</p>
              <p>患者在急诊初步诊断为腹痛待查，疑似急性胃肠炎，因患者疼痛严重住院留观。</p>
              <p>对症治疗后患者症状无改善，遂进行腹部CT进一步检查，确诊为剥离性大动脉瘤。</p>

              <p>剥离范围较大，但动脉瘤并没有破裂，无需紧急手术。</p>
              <p>救援客服中心随时监控患者治疗情况，取得医疗信息并将译成中文的信息共享给企业负责人及患者亲属。</p>
              <p>同时由威马捷顾问医生（航空医疗经验丰富的医生）给出建议：尽量卧床静养，控制血压，</p>
              <p>如果剥离范围没有继续扩大，考虑到患者所在地与中国的距离和飞行时间，
              </p>
              <p>建议现地稳定3周后再考虑医疗转运可大大降低转运风险。</p>
              <p>救援客服中心根据患者身体情况作出医疗转运计划，安排转运医疗团队，</p>
              <p>转运航班及地面转运车辆等具体事宜，并安排了医疗交接及陪同翻译，预约了国内接收医院。</p>
              <p>患者在当地住院21天后，在1名医生和1名护士的陪同下，乘坐商用机的头等舱回国。</p>
              <p>现在患者已经康复并回归了职场。</p>
            </div>
          </CarouselItem>
        </Carousel>

      </div>
    </div>

    <div class="about-ab bgA09"
         :style="{minHeight: clientHeight + 'px'}">
      <div class="page-content">
        <h2 class="content-title02">Inbound</h2>
        <h3 class="content-subtitle">在华医疗援助</h3>
        <div class="page-inbound">
          <div>
            <p>威马捷的数据系统收录中国（包括港澳台）医疗机构约2,000家，</p>
            <p>合作代理服务机构约1,000家，为在中国的外籍人士和华人会员提供预约医院，</p>
            <p>住院期间的医疗监控，医疗转运，遗体转运等紧急医疗救援服务。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="about-ab bgA05"
         :style="{minHeight: clientHeight + 'px'}">
      <div class="page-content">
        <h2 class="content-title02">Outbound</h2>
        <h3 class="content-subtitle">境外医疗援助</h3>
        <div class="page-inbound">
          <div>
            <p>威马捷的全球合作网络对象包括保险公司，</p>
            <p>著名商社，大型跨国企业，医疗机构，大使馆，政府机构，</p>
            <p>知名留学机构，救援包机公司，翻译公司，律师事务所及安保公司等。</p>
            <p>共收录全球医疗机构信息超过20,000家，海外服务供应商信息约3,000家，</p>
            <p>这些信息资源通过呼叫中心的应用成为全球救援服务的重要组成部分。</p>
            <p>威马捷协助中国客户前往境外就医，并为境外华人提供紧急医疗救援服务。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="about-ab bgA08"
         :style="{minHeight: clientHeight + 'px'}">
      <div class="page-content">
        <h2 class="content-title02">Outbound</h2>
        <h3 class="content-subtitle">国际救援项目</h3>
        <div class="page-inbound">
          <div>
            <p style="font-size: 19px;">威马捷独创的医疗转运地图系统AMS，已经收录了EAJ集团近20年的积累数据，</p>
            <p style="font-size: 19px;">可以为常驻海外的企业客户提供包括当地医疗机构信息调查及紧急转运方案等预估风险对策。</p>
            <p style="font-size: 19px;">威马捷作为中国与境外医疗机构的桥梁，协助国外医疗机构在中国的相关峰会参展，</p>
            <p style="font-size: 19px;">促进中外医疗机构间的技术及人才交流。</p>
            <p style="font-size: 19px;">威马捷为大型活动或参会企业，提供集会活动的紧急救援服务。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="under-link">
      <ol class="under-link-wrap">
        <li>
          <router-link to="/about">
            <span>关于威马捷</span>
            <i class="link-arrow"></i>
          </router-link>
        </li>
        <li>
          <router-link to="/activities"
                       class="active">
            <span>威马捷服务</span>

          </router-link>
        </li>
        <li>
          <router-link to="/assistances">
            <span>医疗救援的必要性</span>
            <i class="link-arrow"></i>
          </router-link>
        </li>
      </ol>
    </div>
    <!-- <div class="page-serve">
        <h4>我们服务的集团客户</h4>
        <div class="serve-customer">
          <div>
            <img :src="global" alt="">
            <p>国际医疗保险</p>
          </div>
          <div>
            <img :src="global" alt="">
            <p>国际医疗保险</p>
          </div>
          <div>
            <img :src="global" alt="">
            <p>国际医疗保险</p>
          </div>
        </div>
      </div>  -->
  </div>
</template>
<script>
import scroll from '@/assets/images/about/about_scroll.png';
import service from '@/assets/images/rescue/icon-service.png'
import global from '@/assets/images/home/icon-link1.png'
export default {
  data () {
    return {
      scroll,
      global,
      service,
      carouselIndex: 0,
      carouselSetting: {
        autoplay: false,
        autoplaySpeed: 2000,
        dots: 'outside',
        radiusDot: true,
        trigger: 'click',
        arrow: 'always'
      },
      clientHeight: ''
    }
  },
  mounted () {
    var h = document.documentElement.clientHeight || document.body.clientHeight;

    this.clientHeight = h;
    // console.log(this.clientHeight)
  }
}
</script>
<style lang="less" scoped>
img {
  backface-visibility:hidden;
  -webkit-backface-visibility:hidden;
}
.about-main {
  width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 0;
  clear: both;
  zoom: 1;
  position: relative;
  z-index: 0;
}
.about-ab {
  width: 100%;
  padding: 60px 0;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.bgA06 {
  background-image: url('../assets/images/about/about_top_bg05.png');
  background-position: center top;
}
.bgA07 {
  background-image: url('../assets/images/about/about_top_bg02.jpg');
  background-position: center top;
}
.bgA08 {
  background-color: #d57b63;
  background-image: url('../assets/images/about/about_top_bg03.png');
  background-position: center 88%;
  background-size: 80%;
}
.bgA09 {
  background-image: url('../assets/images/about/about_top_bg06.png');
  background-position: center top;
}
.bgA05 {
  background-image: url('../assets/images/about/about_top_bg120.png');
  background-position: center top;
}
.page-title:before {
  position: absolute;
  left: 0;
  top: 0;
  content: '';
  display: block;
  width: 10px;
  height: 60px;
  background: none;
}
.page-title {
  background: none!important;
  h2 {
    font-size: 60px;
    color: #fff;
    line-height: 70px;
    text-align: center;
    margin-bottom: 28px;
    span {
      color: #cf1300;
    }
  }
  h3 {
    width: 204px;
    height: 58px;
    background: rgba(0, 0, 0, 0.3);
    border: 2px solid #fff;
    color: #fff;
    font-size: 28px;
    line-height: 28px;
    text-align: center;
    line-height: 58px;
    margin: 0 auto 34px;
  }
  .page-scroll {
    width: 80px;
    height: 80px;
    margin: 0 auto;
  }
}
.page-content {
  .content-title01 {
    font-size: 60px;
    color: #444;
    line-height: 80px;
    text-align: center;
  }
  .content-title02 {
    font-size: 60px;
    color: #fff;
    line-height: 80px;
    text-align: center;
  }
  .content-subtitle {
    width: 280px;
    height: 40px;
    background: #ab291b;
    font-size: 24px;
    color: #fff;
    line-height: 40px;
    text-align: center;
    padding: 0 14px;
    margin: 0 auto 36px;
  }
  .content-text {
    width: 686px;
    background: #fcfcfc;
    padding: 40px 0 24px;
    margin: 0 auto;
    .content-para {
      margin-bottom: 26px;
    }
    p {
      font-size: 14px;
      color: #444;
      line-height: 26px;
      text-align: center;
    }
  }
}

.demo-carousel {
  position: relative;
  width: 686px;
  height: 354px;
  background: #ddedf5;
  padding: 50px;
  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 168px;
    height: 157px;
  }
  .carouselTitle {
    font-size: 20px;
    color: #0f6aa1;
    line-height: 36px;
    text-align: center;
    margin: 0 auto 20px;
  }
  .carouselContent {
    p {
      color: #444;
      font-size: 16px;
      line-height: 26px;
      text-align: center;
    }
  }
}
.page-inbound {
  display: flex;
  width: 838px;
  height: 360px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  flex-wrap: wrap;

  p {
    font-size: 22px;
    color: #444444;
    line-height: 44px;
    text-align: center;
  }
}
.under-link {
  background: #fff;
  padding: 50px 0;
  .under-link-wrap {
    width: 700px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 auto;
    li {
      width: 160px;
      height: 160px;
      margin: 0 auto;
      a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border: solid 2px #aa2619;
        color: #aa2619;
        border-radius: 50%;
        span {
          display: block;
          display: block;
          margin-top: 40px;
          font-size: 16px;
        }
        .link-arrow {
          display: block;
          width: 20px;
          height: 20px;
          margin-top: 20px;
          background: url('../assets/images/about/arrow-circle-up.png')
          no-repeat center;
          background-size: 100% auto;
        }
      }
      a.active {
        color: #fff;
        background-color: #aa2619;
        span {
          margin-top: 2px;
        }
      }
    }
  }
}
.page-serve {
  padding: 50px 0;
  h4 {
    font-size: 26px;
    color: #333130;
    line-height: 30px;
    text-align: center;
    margin-bottom: 34px;
  }
  .serve-customer {
    width: 1000px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin: 0 auto;
    div {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 300px;
      height: 110px;
      background: #fff;
      border: 1px solid #d6d6d6;
      padding: 20px;
      img {
        width: 60px;
        height: 60px;
        margin-right: 16px;
      }
      p {
        font-size: 30px;
        color: #ae1e10;
        line-height: 60px;
      }
    }
  }
}
.service-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 838px;
  background: #fff;
  padding: 20px 50px;
  .service-about {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    width: 368px;
    height: 85px;
    margin-bottom: 35px;
    .service-icon {
      display: inline-block;
      width: 70px;
      height: 70px;
      background: url('../assets/images/rescue/icon-service.png') no-repeat;
      margin-right: 18px;
    }
    .service01 {
      background-position: 0 0;
    }
    .service02 {
      background-position: 0 -80px;
    }
    .service03 {
      background-position: 0 -160px;
    }
    .service04 {
      background-position: 0 -240px;
    }
    .service05 {
      background-position: 0 -319px;
    }
    .service06 {
      background-position: 0 -399px;
    }
    .service07 {
      background-position: 0 -479px;
    }
    .service08 {
      background-position: 0 -559px;
    }
    .service09 {
      background-position: 0 -639px;
    }
    .service10 {
      background-position: 0 -719px;
    }
    .service-content {
      h5 {
        font-size: 16px;
        color: #191919;
        line-height: 30px;
        margin-bottom: 15px;
      }
      p {
        font-size: 12px;
        color: #6e6671;
        line-height: 20px;
      }
    }
  }
}
</style>
<style lang="less">
.ivu-carousel {
  .ivu-carousel-arrow {
    width: 80px;
    height: 80px;
    font-size: 4em;
  }
  .ivu-carousel-arrow.left {
    left: -20%;
  }
  .ivu-carousel-arrow.right {
    right: -20%;
  }
}
.ivu-carousel-dots li {
  width: 30px;
  height: 30px;
  button {
    opacity: 1;
  }
  button.radius {
    width: 30px;
    height: 30px;
    background: #fff;
  }
}
.ivu-carousel-dots li.ivu-carousel-active > button.radius {
  width: 30px;
  height: 30px;
  background: #a3362d;
}
</style>
